import { render, staticRenderFns } from "./KeyPassIcon.vue?vue&type=template&id=89d5249a&"
import script from "./KeyPassIcon.vue?vue&type=script&lang=js&"
export * from "./KeyPassIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports